var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-tooltip",
    {
      staticClass: "flex-grow",
      attrs: { content: "Open device's Alarm Desktop", placement: "bottom" },
    },
    [
      _c(
        "el-link",
        {
          attrs: {
            type: "primary",
            target: "_blank",
            underline: false,
            href: _vm.url,
          },
        },
        [_c("i", { staticClass: "el-icon-link" })]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }